import React, { useState, useEffect } from 'react';
import { ArrowRight, Code, Building, Lightbulb, Zap, Users, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TypeAnimation } from 'react-type-animation';

// // TypeAnimation Component
// const TypeAnimation = ({ sequence, wrapper: Wrapper = 'span', speed = 50, repeat = Infinity, cursor = false }) => {
//     const [currentText, setCurrentText] = useState('');
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isTyping, setIsTyping] = useState(true);

//     useEffect(() => {
//         let timeout;
//         const currentSequence = sequence[currentIndex];

//         if (typeof currentSequence === 'string') {
//             if (isTyping) {
//                 if (currentText.length < currentSequence.length) {
//                     timeout = setTimeout(() => {
//                         setCurrentText(currentSequence.slice(0, currentText.length + 1));
//                     }, speed);
//                 } else {
//                     setIsTyping(false);
//                     timeout = setTimeout(() => {
//                         setCurrentIndex((prev) => (prev + 2) % sequence.length);
//                         setCurrentText('');
//                         setIsTyping(true);
//                     }, sequence[currentIndex + 1] || 2000);
//                 }
//             }
//         }

//         return () => clearTimeout(timeout);
//     }, [currentText, currentIndex, isTyping, sequence, speed]);

//     return (
//         <Wrapper>
//             {currentText}
//             {cursor && <span className="animate-pulse">|</span>}
//         </Wrapper>
//     );
// };

const Banner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);


    return (
        <div className="fusion-banner position-relative min-vh-100 overflow-hidden">
            {/* Animated Background Elements */}
            <div className="banner-bg-blobs">
                <div className="banner-blob banner-blob-1"></div>
                <div className="banner-blob banner-blob-2"></div>
                <div className="banner-blob banner-blob-3"></div>
            </div>
            {/* Floating Geometric Shapes */}
            <div className="banner-floating-shapes">
                {[...Array(6)].map((_, i) => (
                    <div
                        key={i}
                        className={`banner-float-dot`}
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${i * 0.5}s`,
                            animationDuration: `${3 + Math.random() * 2}s`
                        }}
                    />
                ))}
            </div>
            {/* Main Content */}
            <div className="container position-relative z-2 d-flex flex-column align-items-center justify-content-center min-vh-100 h-100 text-center">
                {/* TypeAnimation Section */}
                <div className={`banner-fadein ${isVisible ? 'show' : ''}`}>
                    <div className="mb-4 position-relative">
                        <h3 className=" font-weight-light text-black mb-4 d-flex align-items-center justify-content-center min-vh-10" style={{ minHeight: '3rem' }}>
                            <TypeAnimation
                                sequence={[
                                    'Fusion Hub Where Expertise Meets Execution.',
                                    2000,
                                    'Your business, our solutions fused together.',
                                    2000,
                                    'One hub. Many solutions. Endless possibilities.',
                                    2000
                                ]}
                                wrapper="span"
                                speed={50}
                                repeat={Infinity}
                                cursor={false}
                            />
                        </h3>
                        <div className="w-32 h-1 bg-gradient-to-r from-orange-400 to-yellow-300 mx-auto rounded-full"></div>
                    </div>
                </div>

                {/* Description */}
                <div className={`banner-fadein ${isVisible ? 'show' : ''}`}>
                    <p className="text-white-90 mx-auto mb-4 text-center" style={{ maxWidth: '600px' }}>
                        A multidisciplinary solutions provider offering IT Solutions, Civil Engineering, Lighting Design, and more.
                        We blend technology, creativity, and expertise to turn ideas into reality with our diverse team of professionals.
                    </p>
                </div>
                {/* CTA Buttons */}
                <div className={`banner-fadein ${isVisible ? 'show' : ''}`}>
                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-3">
                        <div className="text-center">
                            <Link className="btn btn-black text-white btn-rounded" to="/contact">Get Started</Link>
                        </div>
                    </div>
                </div>
                {/* Scroll Indicator */}
                <div className="banner-scroll-indicator position-absolute w-100" style={{ bottom: '2rem', left: 0 }}>
                    <div className="d-flex justify-content-center">
                        <a href='#what-we-do' className="banner-scroll-mouse border border-light rounded-pill d-flex align-items-center justify-content-center" style={{ width: '28px', height: '44px',  animation: 'bannerScrollPulse 1.5s infinite' }}>
                            <div className="bg-light rounded-pill" style={{ width: '4px', height: '14px', marginTop: '6px'}}></div>
                        </a>
                    </div>
                </div>

            </div>
            {/* Floating Particles */}
            <div className="banner-floating-particles">
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        className="banner-float-particle"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 3}s`,
                            animationDuration: `${2 + Math.random() * 3}s`
                        }}
                    />
                ))}
            </div>
            {/* Custom CSS */}
            <style>{`
                .fusion-banner {
                    background: linear-gradient(to bottom right, #fb7861, #ffc1075c, #fb7861);
                    height: 70vh;
                    display: flex;
                    align-items: center;
                }
                .fusion-banner h3 span {
                    font-size: 36px;
                    font-weight: 600;
                }
                
                .icon-color{
                    color: #ec5244;
                }
                
                .banner-fadein { opacity: 0; transform: translateY(30px); transition: all 1s cubic-bezier(.77,0,.18,1); }
                .banner-fadein.show { opacity: 1; transform: translateY(0); }
                .banner-scroll-indicator { z-index: 3; }
                .banner-scroll-mouse { 
                    border-width:2px !important;
                    width:28px;
                    height:44px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    border-radius: 30px;
                    cursor: pointer;
                }
                
                @media (max-width: 767px) {
                    .fusion-banner { height: 70vh; }
                }
                @keyframes bannerScrollPulse {
                    0% {
                        transform: translateY(0);
                        opacity: 1;
                    }
                    50% {
                        transform: translateY(10px);
                        opacity: 0.3;
                    }
                    100% {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
};

export default Banner;